import { useState } from 'react';
import { useDispatch } from 'react-redux';

import { REQUEST_UPDATE_MATCH_CONTROL_CONTESTANT_MEMBERS } from 'src/redux/reducers/matchControls';
import { Contestant } from 'src/types/matchControl/contestant';

import { MatchControlButton, MatchControlIcon } from '../../components';
import LineUpDialog from '../../components/LineUp/LineUpDialog';
import styles from '../../MatchControl.module.scss';

type LineUpButtonProps = {
  contestant: Contestant;
};

type LineUpProps = {
  home: Contestant;
  away: Contestant;
};

export const LineUpButton = ({ contestant }: LineUpButtonProps) => {
  const dispatch = useDispatch();
  const [open, setOpen] = useState(false);

  const hasLineUp = contestant.members && contestant.members.length > 0;

  const handleSubmitLineUp = (members: Contestant['members']) => {
    dispatch({
      type: REQUEST_UPDATE_MATCH_CONTROL_CONTESTANT_MEMBERS,
      payload: {
        contestantId: contestant.id,
        members,
      },
    });

    setOpen(false);
  };

  return (
    <>
      <MatchControlButton onClick={() => setOpen(true)} className="gap-2" variant="icon">
        <MatchControlIcon iconProps={{ icon: hasLineUp ? 'pencil' : 'plus' }} />
        {hasLineUp ? 'Edit Line-up' : 'Add Line-up'}
      </MatchControlButton>
      <LineUpDialog
        open={open}
        setOpen={setOpen}
        contestant={contestant}
        onSubmit={handleSubmitLineUp}
      />
    </>
  );
};

export const LineUp = ({ home, away }: LineUpProps) => (
  <div className={styles.ItemWrapper}>
    <div className={styles.CurrentCardWrapper}>
      {[home, away].map((contestant) => (
        <div key={contestant.id} className={styles.CardWrapper}>
          <LineUpButton contestant={contestant} />
        </div>
      ))}
    </div>
  </div>
);
